<template>
  <div>
    <el-form ref="form" :model="form" label-width="160px" :disabled="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="照片展示" required>
            <ImgReview
              lebal="实际承运人身份证人像面照片"
              :src="form.identificationImg"
              error="未上传"
            />
            <ImgReview
              lebal="实际承运人身份证国徽面照片"
              :src="form.identificationBackImg"
              error="未上传"
            />
            <ImgReview
              lebal="实际承运人半身照"
              :src="form.driverImg"
              error="未上传"
            />
            <ImgReview
              lebal="机动车驾驶证照片"
              :src="form.driverLicenseImg"
              error="未上传"
            />
            <ImgReview
              lebal="道路运输从业资格证照片"
              :src="form.workLicenseImg"
              error="未上传"
            />
            <ImgReview
              lebal="安全责任险照片"
              :src="form.safeDutyInsureImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="驾驶员姓名">
            <el-input v-model="form.name" placeholder="驾驶员姓名" />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别" clearable>
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式">
            <el-input
              v-model="form.phone"
              autocomplete="off"
              placeholder="联系方式"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="密码，默认abcd1234"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号">
            <el-input
              v-model="form.identificationNumber"
              placeholder="身份证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              disabled
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通信地址">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址">
            <el-input v-model="form.homeAddress" placeholder="详细地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作单位">
            <el-input v-model="form.workCompany" placeholder="工作单位" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="准驾类型">
            <el-input v-model="form.vehicleClass" placeholder="准驾类型" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机动车驾驶证发证机关">
            <el-input
              v-model="form.driverIssuingOrganizations"
              placeholder="机动车驾驶证发证机关"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机动车驾驶证有效期自">
            <el-input
              v-model="form.driverLicenseFromDate"
              placeholder="机动车驾驶证有效期自"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            label="机动车驾驶证有效期至"
            prop="driverLicenseDueDate"
          >
            <el-date-picker
              v-model="form.driverLicenseDueDate"
              :class="form.hasDriverDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择驾驶证有效期结束日期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDriverDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDriverDueDate"
              disabled
              @change="
                value => {
                  this.$set(
                    form,
                    'driverLicenseDueDate',
                    value ? '9999-12-31' : ''
                  );
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输从业资格证到期日期">
            <el-input
              v-model="form.workLicenseDueDate"
              placeholder="道路运输从业资格证到期日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机动车驾驶证号">
            <el-input
              v-model="form.driverLicense"
              placeholder="机动车驾驶证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输从业资格证号">
            <el-input
              v-model="form.workLicense"
              placeholder="道路运输从业资格证号"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form v-if="isReview" ref="formData" :model="form" label-width="180px">
      <el-form-item label="" prop="authMsg">
        <el-input
          v-model="authMsg"
          placeholder="请输入审核(驳回)信息"
          type="textarea"
          maxlength="100"
          show-word-limit
          :autosize="{ minRows: 4 }"
          clearable
        />
      </el-form-item>
    </el-form>
    <el-row v-if="isReview" class="_btns">
      <el-button type="primary" @click="funcSubmit">
        审核通过
      </el-button>
      <el-button type="danger" @click="funcRefuse">
        审核驳回
      </el-button>
    </el-row>
  </div>
</template>
<script>
import ImgReview from "@/components/ImgReview";
import request from "@/utils/request";
export default {
  name: "DriverDetail",
  components: {
    ImgReview
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          model: "detail",
          areaOptions: []
        };
      }
    }
  },
  data() {
    return {
      isCtms: true, //默认显示  同城系统隐藏
      code: "",
      authMsg: "",
      form: {
        idCardDueDate: ""
      },
      reportProvinceName: "",
      // 实际承运人属性
      attributeOptions: [
        { label: "外协", value: 0 },
        { label: "自有", value: 1 }
      ]
    };
  },
  computed: {
    isReview() {
      return this.parentData.model == "review" ? true : false;
    }
  },
  created() {
    this.reportProvinceName = this.reportProvince();
  },
  methods: {
    getDriver(code) {
      this.code = code;
      request({
        url: `/ntocc-basic-api/driver/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
        this.authMsg = response.data.authMsg || "";
        this.$set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
      });
    },
    // 同意审核
    funcSubmit() {
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/updateAuthStatus`,
        method: "post",
        params: {
          code: this.code,
          authStatus: 3
        }
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    },
    // 拒绝审核
    funcRefuse() {
      if (this.authMsg.trim() == "") {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/updateAuthStatus`,
        method: "post",
        params: {
          code: this.code,
          authStatus: 2,
          authMsg: this.authMsg
        }
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    }
  }
};
</script>
<style scoped>
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
}
.avatar-uploader ::v-deep.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  box-sizing: border-box;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #c0ccda;
}
.avatar-uploader-icon:hover {
  border-color: #409eff;
}
.avatar {
  width: 148px;
  height: 148px;
  display: block;
}

.el-date-editor {
  width: 100%;
}
._btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
